"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepFlowItem = void 0;
var _step_flowModule = _interopRequireDefault(require("@albelli/arc-3/lib/step_flow.module.css"));
var _stepsModule = _interopRequireDefault(require("@albelli/arc-3/lib/steps.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const StepFlowItem = _ref => {
  let {
    children,
    current,
    classNames,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)(_step_flowModule.default["arc3-step"], {
      [_step_flowModule.default["arc3-step--current"]]: current
    }, {
      "arc3-step--current": current
    }, classNames)
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_stepsModule.default["arc3-steps-rounded"], _step_flowModule.default["arc3-steps-rounded"], _stepsModule.default["arc3-steps-rounded--small"], _stepsModule.default["arc3-steps-rounded--cyan"])
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, null)), /*#__PURE__*/_react.default.createElement("span", {
    className: _step_flowModule.default["arc3-step--label"]
  }, children));
};
exports.StepFlowItem = StepFlowItem;
StepFlowItem.propTypes = {
  /** Shows SideMenuItem label  */
  children: _propTypes.default.string,
  /** SideMenuItem is current step */
  current: _propTypes.default.bool,
  /** Custom CSS classes */
  classNames: _propTypes.default.string
};